import { useCallback } from 'react'
import { runInAction } from 'mobx'

import { usePostPreviewStore } from '../PostPreviewStoreProvider'
import { usePostPropertyMutations } from './usePostPropertyMutations'
import { PostPreviewScreens } from '../PostPreviewStore'
import { PostStatusPropertyValue } from 'api/clients/PropertyClient'

export function usePostUnscheduleService() {
  const store = usePostPreviewStore()
  const { updateStatus, updatePostAt } = usePostPropertyMutations()

  /** Sets every selected file back to a draft (post_at = null). */
  const unschedule = useCallback(async () => {
    const states = [...store.postStates] // works for 1 or many files

    await Promise.all(
      states.map(async (s) => {
        await updatePostAt(s.fileId, null) // <- post_at → null :contentReference[oaicite:0]{index=0}
        await updateStatus(s.fileId, PostStatusPropertyValue.Draft)

        /* reflect instantly in the UI */
        runInAction(() =>
          store.updatePostState(s.fileId, {
            runtime: 'success',
            result: 'draft',
            postAt: undefined,
          }),
        )
      }),
    )

    /* jump back to “Select Channels” */
    store.setScreen(PostPreviewScreens.CHANNEL_SCREEN) // :contentReference[oaicite:1]{index=1}
  }, [store, updatePostAt, updateStatus])

  return { unschedule }
}
